<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h5 class="no-margin"><i class="fa fa-cogs text-muted mr-5"></i>{{'cc_override' | translate}}:</h5>
          </div>
          <div class="box-body">
            <div class="col-xs-12">
              <template v-if="this.loading">
                <div class="row">
                  <div class="col-xs-12 text-center">
                    <img class="loading-gif" src="/static/img/blabla.svg"/>
                  </div>
                </div>
              </template>
              <table v-else class="table table-hover">
                <thead>
                <tr>
                  <th>{{ 'cc_id' | translate }}</th>
                  <th>{{ 'carrier' | translate }}</th>
                  <th>{{ 'carrier_service_method' | translate }}</th>
                  <th>{{ 'use_store_key' | translate }}</th>
                  <th>{{ 'action' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="ccOverride, overrideId in configs">
                  <td>{{ ccOverride.country_carrier_id }}</td>
                  <td>{{ ccOverride.carrier }}</td>
                  <td>{{ ccOverride.carrier_service_method }}</td>
                  <td>{{ ccOverride.use_store_key }}</td>
                  <td>
                    <button
                      class="btn btn-flat btn-info mb-10 mt-10"
                      data-toggle="modal"
                      data-target="#countryCarrierOverrideConfigModal"
                      @click="openSalesChannelConfigModal(overrideId)">
                      <i class="fa fa-wrench mr-5"></i>
                      {{'edit'|translate}}
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="box-footer">
            <button
              class="btn btn-flat btn-success mb-10 mt-10 pull-right"
              data-toggle="modal"
              data-target="#countryCarrierOverrideConfigModal"
              @click="openNewWindowModal()"
            ><i class="fa fa-plus mr-5"></i>{{'add' | translate}}</button>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h5 class="no-margin"><i class="fa fa-cogs text-muted mr-5"></i>{{'preferred_carrier' | translate}}:</h5>
          </div>
          <div class="box-body">
            <div class="col-xs-12">
              <template v-if="this.loading">
                <div class="row">
                  <div class="col-xs-12 text-center">
                    <img class="loading-gif" src="/static/img/blabla.svg"/>
                  </div>
                </div>
              </template>
              <table v-else class="table table-hover">
                <thead>
                <tr>
                  <th>{{ 'carrier' | translate }}</th>
                  <th>{{ 'direction' | translate }}</th>
                  <th>{{ 'carrier_service_method' | translate }}</th>
                  <th>{{ 'is_preferred_carrier_mid' | translate }}</th>
                  <th>{{ 'is_preferred_carrier_max' | translate }}</th>
                  <th>{{ 'parcel_options' | translate }}</th>
                  <th>{{ 'action' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="shippingConfig, configId in shippingConfigs">
                  <td>{{ shippingConfig.carrier }}</td>
                  <td>{{ shippingConfig.direction }}</td>
                  <td>{{ shippingConfig.carrier_service_method }}</td>
                  <td>{{ shippingConfig.is_preferred_carrier_mid }}</td>
                  <td>{{ shippingConfig.is_preferred_carrier_max }}</td>
                  <td>
                    <template v-if="parcelOptions[configId] !== undefined">
                      {{'weight' | translate}}: {{ parcelOptions[configId]['weight'] }}<br />
                      {{'height' | translate}}: {{ parcelOptions[configId]['height'] }}<br />
                      {{'width' | translate}}: {{ parcelOptions[configId]['width'] }}<br />
                      {{'length' | translate}}: {{ parcelOptions[configId]['length'] }}<br />
                      {{'carrier' | translate}}: {{ parcelOptions[configId]['carrier'] }}<br />
                      {{'parcel_type' | translate}}: {{ parcelOptions[configId]['parcel_type'] }}
                    </template>
                  </td>
                  <td>
                    <button
                      class="btn btn-flat btn-success mb-10 mt-10"
                      data-toggle="modal"
                      data-target="#parcelOptionConfigModal"
                      @click="openParcelOptionModal(configId)">
                      <i class="fa fa-wrench mr-5"></i>
                      {{'parcel_option_edit'|translate}}
                    </button>
                    <button
                      class="btn btn-flat btn-info mb-10 mt-10"
                      data-toggle="modal"
                      data-target="#shippingConfigModal"
                      @click="openShippingConfigModal(configId)">
                      <i class="fa fa-wrench mr-5"></i>
                      {{'edit'|translate}}
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="box-footer">
            <button
              class="btn btn-flat btn-success mb-10 mt-10 pull-right"
              data-toggle="modal"
              data-target="#shippingConfigModal"
              @click="openNewShippingWindowModal()"
            ><i class="fa fa-plus mr-5"></i>{{'add' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
    <CountryCarrierOverrideConfigModal id="countryCarrierOverrideConfigModal" :isNew="openNewWindow" :modalSalesChannelConfig="modalSalesChannelConfig" @newOverrideCreated="requestOverrides"></CountryCarrierOverrideConfigModal>
    <ShippingConfigModal id="shippingConfigModal" :isNew="openNewWindow" :modalShippingConfig="modalShippingConfig" @newConfigCreated="requestConfigs"></ShippingConfigModal>
    <ParcelOptionConfigModal id="parcelOptionConfigModal" :modalParcelOption="modalParcelOption" :modalShippingConfig="modalShippingConfig" :isNew="openNewWindow" @newParcelOptionCreated="requestParcelOptions"></ParcelOptionConfigModal>
  </section>
</template>

<script>
export default {
  name: "EditCompanyShipping",
  data() {
    return {
      shippingConfigId: 0,
      shippingConfigs: {},
      parcelOptions: {},
      configs: {},
      modalSalesChannelConfig: {},
      modalShippingConfig: {},
      modalParcelOption: {},
      openNewWindow: false,
      loading: true
    }
  },
  methods: {
    requestParcelOptions() {
      API.get(`accounting/companies/${this.$route.params.id}/shipping/parcel`)
        .then(res => {
          this.parcelOptions = res.data
      });
    },
    requestOverrides() {
      API.get(`accounting/companies/${this.$route.params.id}/config/override/`)
        .then(res => {
          this.configs = res.data
        });
    },
    requestConfigs() {
      API.get(`accounting/companies/${this.$route.params.id}/shipping/config`)
        .then(res => {
          this.shippingConfigs = res.data
        });
    },
    openParcelOptionModal(configId) {
      if (this.parcelOptions[configId] === undefined) {
        this.modalParcelOption = {}
        this.modalShippingConfig = this.shippingConfigs[configId]
        this.openNewWindow = true
      } else {
        this.modalShippingConfig = this.shippingConfigs[configId]
        this.modalParcelOption = this.parcelOptions[configId]
        this.openNewWindow = false
      }
    },
    openShippingConfigModal(configId) {
      this.modalShippingConfig = this.shippingConfigs[configId]
      this.openNewWindow = false
    },
    openSalesChannelConfigModal(configId) {
      this.modalSalesChannelConfig = this.configs[configId]
      this.openNewWindow = false
    },
    openNewWindowModal() {
      this.modalSalesChannelConfig = {}
      this.openNewWindow = true
    },
    openNewShippingWindowModal() {
      this.modalShippingConfig = {}
      this.openNewWindow = true
    },
  },
  mounted() {
    API.get(`accounting/companies/${this.$route.params.id}/config/override/`)
      .then(res => {
        this.configs = res.data
        API.get(`accounting/companies/${this.$route.params.id}/shipping/config`)
          .then(res => {
            this.shippingConfigs = res.data
            API.get(`accounting/companies/${this.$route.params.id}/shipping/parcel`)
              .then(res => {
                this.loading = false
                this.parcelOptions = res.data
            })
        })
      })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/EditCompanyShipping.vue